import hero2 from '@/assets/images/auth/hero-img-2.jpg'
import BrandTitle from '@/components/custom/brand'

import { OnboardingForm } from '../components/onboarding-form'

export default function OnboardingPage() {
    return (
        <div className="grid min-h-svh lg:grid-cols-2">
            <div className="flex flex-col gap-4 p-6 md:p-10">
                <div className="flex justify-center gap-2 md:justify-start">
                    <a href="/" className="flex items-center gap-2 font-medium">
                        <BrandTitle />
                    </a>
                </div>
                <div className="flex flex-1 items-center justify-center">
                    <div className="w-full max-w-xl">
                        <OnboardingForm />
                    </div>
                </div>
            </div>
            <div className="bg-muted relative hidden lg:block">
                <img
                    src={hero2}
                    alt="Filmmaking onboarding"
                    className="absolute inset-0 h-full w-full object-cover"
                    width={1920}
                    height={1080}
                />
                <div className="absolute inset-0 bg-black/35" />
                <div className="absolute bottom-10 left-10 max-w-md text-white">
                    <p className="text-sm uppercase tracking-[0.2em] text-white/70">Onboarding</p>
                    <h2 className="mt-3 text-4xl font-semibold leading-tight">
                        Shape a workspace that matches how you make films.
                    </h2>
                </div>
            </div>
        </div>
    )
}
